import {css} from '../../theme/css'
import {theme} from '../../theme/theme'

export const classes = {
  iconWrap: css`
    inline-size: 32px;
    block-size: 32px;
    transform: translate(-50%, -50%);

    [dir='rtl'] & {
      transform: translate(50%, -50%);
    }

    ${theme.breakpoints.down('sm')} {
      inline-size: 24px;
      block-size: 24px;
    }
  `,
  tooltip: css`
    ${theme.breakpoints.down('sm')} {
      display: none;
    }
  `,
}
